'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'clipboard-check';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f46c';
var svgPathData = 'M256 0c20.9 0 38.7 13.4 45.3 32L320 32c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l18.7 0C89.3 13.4 107.1 0 128 0L256 0zM64 48C37.5 48 16 69.5 16 96l0 352c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-16 0c0 26.5-21.5 48-48 48L128 96c-26.5 0-48-21.5-48-48L64 48zM273.7 211.7c2.6-3.6 7.6-4.3 11.2-1.7 3.6 2.6 4.3 7.6 1.8 11.2L172.9 377.5c-1.4 1.9-3.6 3.1-5.9 3.3s-4.7-.7-6.3-2.4L98.3 313.9c-3.1-3.2-3-8.2 .2-11.3s8.2-3 11.3 .2l55.7 57.6 108.1-148.7zM128 16c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClipboardCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;